export const XHR_BASE_PATH = '/_napi/da-deviation/';
export const SHARED_API_BASE_PATH = `${XHR_BASE_PATH}shared_api`;

export const acceptableDeviationTypes = [
  'art',
  'journal',
  'commission',
  'status-update',
  'poll',
  'tier',
];
